/* FalcX r10: "The Falcon list" signup interests (snippets/falcx-signup-interests.liquid, used by
   sections/falcx-footer-main.liquid and sections/falcx-newsletter.liquid).
   - Tap Subscribe with a valid email: a modal <dialog> asks what the shopper is into (parts, "All of it", their Falcon).
     "Subscribe" sends the base tags plus one tag per choice; "Skip" sends the base tags only. Close / Esc cancels.
   - The real Shopify customer form then submits (requestSubmit, so any Shopify bot check still runs); tags go in its
     hidden contact[tags] field.
   - An invalid email never opens the dialog: the browser's own message shows instead.
   - Back from Shopify (success or error), the signup panel is scrolled into view, not left under the header.
   Without JavaScript (or without <dialog> support) the plain form submits with the base tags, as before. */
(function (root) {
  'use strict';

  function clean(tag) {
    return String(tag == null ? '' : tag).trim().toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* Pure part, exported for tests.
     base: "newsletter,falcon-list"; picked: ticked interest tags (may include allTag); all: every single interest tag
     (not allTag); series: "ba-bf" or "". "All of it", or every single interest ticked, sends every interest tag plus
     allTag, so a segment on any one interest still finds people who picked "All of it". */
  function buildTags(base, picked, all, series, allTag) {
    allTag = allTag || 'interest-all';
    var list = [];
    function add(tag) {
      tag = clean(tag);
      if (tag && list.indexOf(tag) === -1) list.push(tag);
    }
    String(base || '').split(',').forEach(add);
    picked = (picked || []).map(clean);
    all = (all || []).map(clean).filter(Boolean);
    var everything = picked.indexOf(allTag) !== -1 || (all.length > 0 && all.every(function (t) { return picked.indexOf(t) !== -1; }));
    if (everything) {
      all.forEach(add);
      add(allTag);
    } else {
      picked.forEach(function (t) { if (t !== allTag && all.indexOf(t) !== -1) add(t); });
    }
    var s = clean(series);
    if (s) add('falcon-' + s);
    return list.join(',');
  }

  /* State of the "All of it" box from the single boxes: 'all' | 'some' | 'none'. */
  function allState(checked, total) {
    if (!total || !checked) return 'none';
    return checked >= total ? 'all' : 'some';
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = {buildTags: buildTags, allState: allState, clean: clean}; return; }

  var doc = root.document;
  if (!doc || typeof root.HTMLDialogElement !== 'function') return;

  var FOCUSABLE = 'button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), a[href]';

  function setup(dialog) {
    if (dialog.dataset.fxsReady) return;
    var form = dialog.closest('form');
    var hidden = form && form.querySelector('input[name="contact[tags]"]');
    var email = form && form.querySelector('input[name="contact[email]"]');
    if (!form || !hidden || !email || typeof dialog.showModal !== 'function') return;
    dialog.dataset.fxsReady = 'true';

    var base = dialog.getAttribute('data-fxs-base') || hidden.value;
    var boxes = Array.prototype.slice.call(dialog.querySelectorAll('[data-fxs-interest]'));
    var allBox = dialog.querySelector('[data-fxs-all]');
    var series = dialog.querySelector('[data-fxs-series]');
    var send = dialog.querySelector('[data-fxs-submit]');
    var skip = dialog.querySelector('[data-fxs-skip]');
    var sendLabel = send ? send.textContent : '';
    var opener = null;
    var ready = false;

    function syncAll() {
      if (!allBox) return;
      var n = boxes.filter(function (b) { return b.checked; }).length;
      var state = allState(n, boxes.length);
      allBox.checked = state === 'all';
      allBox.indeterminate = state === 'some';
    }
    boxes.forEach(function (b) { b.addEventListener('change', syncAll); });
    if (allBox) allBox.addEventListener('change', function () {
      boxes.forEach(function (b) { b.checked = allBox.checked; });
      allBox.indeterminate = false;
    });

    function busy(on) {
      [send, skip].forEach(function (b) { if (b) b.disabled = on; });
      if (send) send.textContent = on ? (send.getAttribute('data-busy') || sendLabel) : sendLabel;
      dialog.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function finish(withChoices) {
      var picked = [];
      if (withChoices) {
        boxes.forEach(function (b) { if (b.checked) picked.push(b.value); });
        if (allBox && allBox.checked) picked.push(allBox.value);
      }
      hidden.value = buildTags(base, picked, boxes.map(function (b) { return b.value; }), withChoices && series ? series.value : '', allBox ? allBox.value : 'interest-all');
      ready = true;
      busy(true);
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }
    if (send) send.addEventListener('click', function () { finish(true); });
    if (skip) skip.addEventListener('click', function () { finish(false); });
    dialog.querySelectorAll('[data-fxs-close]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.close('cancel'); });
    });
    /* Tap on the backdrop closes too (the dialog box itself fills its own rect). */
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close('cancel');
    });
    dialog.addEventListener('close', function () {
      if (ready) return;
      hidden.value = base;
      var back = opener || form.querySelector('button[type="submit"]') || email;
      if (back && back.focus) back.focus();
    });
    /* Keep Tab inside the dialog (the page behind is already inert while it is modal). */
    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null || el === doc.activeElement; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    function open(submitter) {
      opener = submitter || null;
      if (series && !series.value) {
        try {
          var saved = root.FalcxVehicle && root.FalcxVehicle.getSaved && root.FalcxVehicle.getSaved();
          if (saved && saved.series && series.querySelector('option[value="' + clean(saved.series) + '"]')) series.value = clean(saved.series);
        } catch (err) { /* no saved vehicle */ }
      }
      syncAll();
      busy(false);
      dialog.showModal();
      var first = boxes[0] || send;
      if (first) first.focus();
    }

    /* Capture phase on the document: runs before any other submit listener on this form. */
    doc.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (ready) return; /* our own requestSubmit: let it through */
      e.preventDefault();
      e.stopPropagation();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      open(e.submitter);
    }, true);

    /* After Shopify sends the shopper back (?customer_posted=true#form-id, or #form-id with an error), bring the whole
       signup panel into view below the sticky header, once the page has finished moving. */
    if (form.id && root.location.hash === '#' + form.id) {
      var settle = function () {
        var panel = form.closest('.fxf-sign, .falcx-news, section') || form;
        /* A timer, not a frame callback: it runs after the browser's own jump to #form-id, and in a background tab. */
        root.setTimeout(function () { panel.scrollIntoView({block: 'center'}); }, 60);
      };
      if (doc.readyState === 'complete') settle(); else root.addEventListener('load', settle, {once: true});
    }

    /* Back button (bfcache): start again. */
    root.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      ready = false;
      busy(false);
      hidden.value = base;
      if (dialog.open) dialog.close();
    });
  }

  function init() { doc.querySelectorAll('[data-fxs-dialog]').forEach(setup); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', init);
})(typeof window !== 'undefined' ? window : this);
